import React from 'react';
import PropTypes from 'prop-types';
import { renderToString } from 'react-dom/server';
import { spring, StaggeredMotion } from 'react-motion';
import { Image, SharingPopup } from 'C4';

const ImageCollection = (props) => {
  const { chapter } = props;
  const chapterName = chapter[0].chapter.chapterTitle;
  const chapterNr = chapter[0].chapter.chapterNumber;

  // Dynamically Create enough animation starting values
  const startingValues = [];
  Object.keys(chapter).map(() => {
    const newObj = {};
    newObj.pos = 0;
    return startingValues.push(newObj);
  });

  const fancyOptions = {
    infobar: true,
    thumbs: {
      autoStart: true,
      axis: 'y',
    },
    buttons: ['thumbs', 'share', 'download', 'close'],
    share: {
      tpl: renderToString(<SharingPopup url={window.location.href} />),
    },
    caption: chapterName,
  };

  return (
    <div className="imageGrid__Container">
      <div className="imageGrid__Container--title">
        <h3>{`${chapterName}`}</h3>
        <h5>{`Chapter ${chapterNr}`}</h5>
      </div>
      <StaggeredMotion
        defaultStyles={startingValues}
        styles={prevInterpolatedStyles => prevInterpolatedStyles.map((_, i) => (i === 0
          ? { pos: spring(1, { stiffness: 320, damping: 28 }) }
          : { pos: spring(prevInterpolatedStyles[i - 1].pos, { stiffness: 320, damping: 28 }) }))}
      >
        {styles => (
          <div className="imageGrid__Grid">
            {Object.values(chapter).map((item, index) => {
              const { pageID, image, title } = item;
              return (
                <div className="imageGrid_Card" key={pageID} style={{ opacity: `${styles[index].pos}` }}>
                  <Image
                    key={pageID}
                    src={image}
                    gradient
                    onLoad={() => { this.setState({ loading: false }); }}
                    href={image}
                    fancybox={chapterName}
                    options={fancyOptions}
                    caption={title}
                  />
                  <div className="title">{title}</div>
                </div>
              );
            })}
          </div>
        )}
      </StaggeredMotion>
    </div>
  );
};

export default ImageCollection;

ImageCollection.propTypes = {
  chapter: PropTypes.arrayOf.isRequired,
};
